<div
  class="confirm-dialog-backdrop"
  [class.is-visible]="confirmDialogService.isOpen()"
  (click)="onBackdropClick()"
  aria-hidden="true"
></div>

@if (confirmDialogService.isOpen() && confirmDialogService.options(); as options) {
  <div
    class="confirm-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="confirm-dialog-message"
    (keydown)="onDialogKeydown($event)"
    tabindex="-1"
  >
    <p id="confirm-dialog-message" class="confirm-dialog-message">{{ options.message }}</p>

    <div class="confirm-dialog-actions">
      <button
        type="button"
        class="btn btn-outline"
        [disabled]="confirmDialogService.loading()"
        (click)="onCancelClick()"
      >
        {{ options.cancelText }}
      </button>
      <button
        type="button"
        class="btn btn-primary confirm-dialog-confirm"
        [disabled]="confirmDialogService.loading()"
        (click)="onConfirmClick()"
      >
        @if (confirmDialogService.loading()) {
          <span class="btn-spinner" aria-hidden="true"></span>
        }
        {{ options.confirmText }}
      </button>
    </div>
  </div>
}
